import { CONTAINER_TRADEIN } from 'Constant';
import { createSelector } from 'reselect';
import { getIsTauschbonusEligible } from '../DeviceDetail/helpers/getIsTauschbonusEligible';
import { IInitialState } from './interface';
import { initialState } from './reducer';

const selectState = (state) => state[CONTAINER_TRADEIN] || initialState;

const selectLoading = () =>
    createSelector(
        selectState,
        (state: IInitialState) => state.loading,
    );

const selectHasError = () =>
    createSelector(
        selectState,
        (state: IInitialState) => state.hasError,
    );

const selectDevices = () =>
    createSelector(
        selectState,
        (state: IInitialState) => state.payload || [],
    );

const selectTradeIn = () =>
    createSelector(
        selectState,
        (state: IInitialState) => !!(state.tradeInSwitch && state.selectedDeviceId),
    );

const selectTauschbonus = () =>
    createSelector(
        selectState,
        (state: IInitialState) => !!(state.tradeInSwitch && state.selectedDeviceId && getIsTauschbonusEligible()),
);

const selectTradeInSwitch = () =>
    createSelector(
        selectState,
        (state: IInitialState) => state.tradeInSwitch,
    );

const selectSuggestFieldValue = () =>
    createSelector(
        selectState,
        (state: IInitialState) => state.suggestFieldValue,
    );

const selectSelectedDeviceId = () =>
    createSelector(
        selectState,
        (state: IInitialState) => state.selectedDeviceId,
    );

const selectIsDeviceNotFound = () =>
    createSelector(
        selectState,
        (state: IInitialState) => !!(state.payload && state.payload.length === 0),
    );

export {
    selectLoading,
    selectHasError,
    selectDevices,
    selectTradeIn,
    selectTradeInSwitch,
    selectSuggestFieldValue,
    selectSelectedDeviceId,
    selectIsDeviceNotFound,
    selectTauschbonus,
};
